import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useListContext } from 'react-admin';
import { FormProvider } from 'react-hook-form';
import { FilterBar, FilterBarActions, FilterBarRow } from 'shared/mui/Filter/FilterBar';
import { FilterApplyButton, FilterResetButton } from 'shared/mui/Filter/FilterButtons';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { useSyncFilter } from 'shared/mui/Filter/hooks/useSyncFilter';
import { TextInput } from 'shared/react-admin/Inputs';

export type MerchantShowRulesFilterValues = {
  name?: string | null;
};

const INITIAL_VALUES = {
  name: null,
};

export const MerchantShowRulesListFilter = () => {
  const translate = useTypedTranslate();
  const { filterValues } = useListContext();

  const { form, onReset, onSubmit, appliedFilters } = useFilters<MerchantShowRulesFilterValues>({
    defaultValues: { ...INITIAL_VALUES, ...filterValues },
    resetValues: INITIAL_VALUES,
  });

  useSyncFilter<MerchantShowRulesFilterValues>({ appliedFilters });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FilterBar>
          <FilterBarRow sx={{ gridTemplateColumns: '1fr 272px' }}>
            <TextInput
              helperText={false}
              label={translate('app.filter.name')}
              source="name"
              variant="outlined"
            />
            <FilterBarActions>
              <FilterResetButton key="reset-button" onReset={onReset} />
              <FilterApplyButton key="apply-button" type="submit" />
            </FilterBarActions>
          </FilterBarRow>
        </FilterBar>
      </form>
    </FormProvider>
  );
};
